
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface PageTransitionProps {
  children: React.ReactNode;
  forceDelay?: number; // Optional delay to ensure animations work
}

const PageTransition: React.FC<PageTransitionProps> = ({ 
  children,
  forceDelay = 0
}) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // This ensures the animation runs after component is fully mounted
    const timer = setTimeout(() => {
      setIsReady(true);
    }, forceDelay);

    return () => clearTimeout(timer);
  }, [forceDelay]);

  return (
    <AnimatePresence mode="wait">
      {isReady && (
        <motion.div
          key="page-content"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ 
            duration: 0.4, 
            ease: [0.22, 1, 0.36, 1],
            delay: 0.1 // Small delay to ensure animations are visible
          }}
        >
          {children}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageTransition;
